// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"717be87d","239":"ae03ce17","455":"27918548","831":"3124111d"}[chunkId] + ".chunk.js";
};